import './sliders/aboutSlider';
import './sliders/homeSlider';
import './sliders/productImageGallerySlider';
//import './sliders/HeroSlider';
//import './sliders/NewsSlider';
//import './sliders/PhilosophySlider';
